var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_vm._m(0),_c('p',{staticClass:"empty-title h5"},[_vm._v(_vm._s(_vm.getCaption("caption.under_construction_title")))]),_c('p',{staticClass:"empty-subtitle"},[_vm._v(_vm._s(_vm.getCaption("caption.under_construction_body")))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-icon"},[_c('i',{staticClass:"fas fa-7x fa-tools"})])
}]

export { render, staticRenderFns }